import React from 'react'
import classNames from 'classnames'
import { LazyHydrate } from '@/atoms/LazyHydrate'
import { ThemeContextProvider } from '@/contexts/ThemeContext'
import type { TrackerResult } from '@/types/codegen-federation'
import { GoalTrackerDisplay } from './GoalTrackerDisplay'

interface GoalTrackerWidgetProps {
  trackerSlug: string
  goalTrackers: Array<TrackerResult | null> | null | undefined
  title?: string
  className?: string
  isDarkMode?: boolean
}

export const GoalTrackerWidget: React.FC<GoalTrackerWidgetProps> = ({
  trackerSlug,
  goalTrackers,
  title,
  className,
  isDarkMode = false,
}) => {
  const tracker = goalTrackers?.find((t) => t?.id === trackerSlug) ?? null

  if (!tracker) return null

  return (
    <div
      className={classNames(
        !isDarkMode && 'border border-solid border-core-gray-200 bg-white',
        'mb-6 rounded-xl px-4 py-4 md:px-6 md:py-12 lg:mb-16 lg:py-6',
        className,
      )}
    >
      <LazyHydrate whenVisible>
        <ThemeContextProvider isDarkMode={isDarkMode}>
          <GoalTrackerDisplay tracker={tracker} title={title} />
        </ThemeContextProvider>
      </LazyHydrate>
    </div>
  )
}
